// ContactWrapper.jsx
import React, { useRef, useState } from "react";
import contact from "../../../assets/images/feedback.png";
import { Button, Form, Input, message } from "antd";
import SendIcon from "../../../global/components/Icons/SendIcon";
import { API_URL } from "../../../lib/apiConstants";
import HCaptcha from "@hcaptcha/react-hcaptcha";

const FeedbackWrapper = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const captchaRef = useRef(null);
  const [captchaToken, setCaptchaToken] = useState(null);

  const handleFinish = async (values) => {
    if (!captchaToken) {
      message.error("Please complete the captcha.");
      return;
    }
    setLoading(true);

    try {
      const payload = {
        name: values.name,
        phone: values.phone,
        email: values.email,
        feedback_title: values.feedback_title,
        feedback_details: values.feedback_details,
        captcha_token: captchaToken,
      };

      const response = await fetch(`${API_URL}/send-feedback-mail`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (response.ok) {
        message.success("Feedback submitted successfully!");
        form.resetFields();
        captchaRef.current?.resetCaptcha();
        setCaptchaToken(null);
      } else {
        message.error(
          data.message || "Failed to submit feedback. Please try again.",
        );
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      message.error("Something went wrong. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="max-w-[1280px] mx-auto px-4 py-10 sm:px-6 lg:px-8 lg:py-16">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-0 bg-white rounded-2xl shadow-lg overflow-hidden">
        {/* Left: Info */}
        <div className="animate-fadeIn">
          <div className="space-y-0 w-full h-full flex flex-col">
            {/* Image Section with Overlay Text */}
            <div className="relative overflow-hidden flex-1">
              <img
                src={contact}
                alt="Contact Us"
                className="w-full h-full object-cover min-h-[400px]"
              />

              {/* Dark Overlay */}
              <div className=""></div>
            </div>
          </div>
        </div>

        {/* Right: Form */}
        {/* Right: Form */}
        <div className="animate-fadeIn flex items-center justify-center">
          <div className="bg-white py-6 px-6 sm:px-8 lg:px-10 max-w-full w-full mx-auto h-full flex flex-col justify-center">
            {/* Header */}
            <div className="mb-6">
              <h2 className="text-[24px] text-center font-bold text-[#121212] font-['Poppins'] mb-3">
                SHARE YOUR FEEDBACK
              </h2>
              <p className="text-[14px] sm:text-[14px]  items-center justify-center ">
                We value your input. Please tell us about your experience or
                suggestions.
              </p>
            </div>

            {/* Form */}
            <Form
              form={form}
              layout="vertical"
              requiredMark={false}
              onFinish={handleFinish}
              className="space-y-2"
            >
              <Form.Item
                label={
                  <span className="text-[#121212] text-[14px] font-medium">
                    Name*
                  </span>
                }
                name="name"
                style={{ marginBottom: 20 }}
                rules={[{ required: true, message: "Please enter your name" }]}
              >
                <Input
                  size="large"
                  placeholder="Write here"
                  className="rounded-sm"
                  style={{ height: "40px" }}
                />
              </Form.Item>

              <Form.Item
                label={
                  <span className="text-[#121212] text-[14px] font-medium">
                    Phone*
                  </span>
                }
                name="phone"
                style={{ marginBottom: 20 }}
                rules={[
                  { required: true, message: "Please enter your phone number" },
                ]}
              >
                <Input
                  size="large"
                  placeholder="Write here"
                  className="rounded-sm"
                  style={{ height: "40px" }}
                />
              </Form.Item>

              <Form.Item
                label={
                  <span className="text-[#121212] text-[14px] font-medium">
                    Email*
                  </span>
                }
                name="email"
                style={{ marginBottom: 20 }}
                rules={[
                  { required: true, message: "Please enter your email" },
                  { type: "email", message: "Enter a valid email address" },
                ]}
              >
                <Input
                  size="large"
                  placeholder="Write here"
                  className="rounded-sm"
                  style={{ height: "40px" }}
                />
              </Form.Item>

              <Form.Item
                label={
                  <span className="text-[#121212] text-[14px] font-medium">
                    Feedback Title*
                  </span>
                }
                name="feedback_title"
                style={{ marginBottom: 20 }}
                rules={[
                  { required: true, message: "Please enter feedback title" },
                ]}
              >
                <Input
                  size="large"
                  placeholder="Write here"
                  className="rounded-sm"
                  style={{ height: "40px" }}
                />
              </Form.Item>

              <Form.Item
                label={
                  <span className="text-[#121212] text-[14px] font-medium">
                    Feedback Details*
                  </span>
                }
                name="feedback_details"
                style={{ marginBottom: 20 }}
                rules={[
                  { required: true, message: "Please enter feedback details" },
                ]}
              >
                <Input.TextArea
                  rows={4}
                  className="resize-none rounded-sm"
                  placeholder="Write here"
                  style={{ minHeight: "120px" }}
                />
              </Form.Item>

              {/* Terms Agreement */}
              {/* <Form.Item
                name="agree"
                valuePropName="checked"
                style={{ marginBottom: 24 }}
              >
                <Checkbox className="text-[#4A4C56] text-[13px] leading-relaxed">
                  We’ll only use your email to respond to your feedback.
                </Checkbox>
              </Form.Item> */}
              <Form.Item style={{ marginBottom: 20 }}>
                <HCaptcha
                  ref={captchaRef}
                  sitekey="231048d6-eb42-4a90-ba0e-7e3ed338da68"
                  onVerify={(token) => setCaptchaToken(token)}
                  onExpire={() => setCaptchaToken(null)}
                />
              </Form.Item>
              {/* Submit Button */}
              <div className="flex justify-center w-full pt-4">
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={loading}
                  disabled={!captchaToken}
                  className="w-full bg-[#007BFF] hover:bg-[#0056b3] text-white px-12 rounded-sm flex items-center justify-center gap-2 transition-all duration-300"
                  style={{
                    height: "40px",
                    fontSize: "15px",
                    fontWeight: "500",
                  }}
                >
                  {loading ? "Submitting..." : "Submit Feedback"}
                  {!loading && <SendIcon className="text-white" />}
                </Button>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeedbackWrapper;
